import { render, staticRenderFns } from "./upload-file.vue?vue&type=template&id=198ac7d1";
import script from "./upload-file.vue?vue&type=script&lang=js";
export * from "./upload-file.vue?vue&type=script&lang=js";
import style0 from "./upload-file.vue?vue&type=style&index=0&id=198ac7d1&prod&lang=less";

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js";
var component = normalizer(script, render, staticRenderFns, false, null, null, null);
export default component.exports;